/**
 * Dev-only save dump.
 *
 * Gated on `localStorage.setItem('edge-dump-chart-saves', '1')`. Pushes a
 * snapshot of every outbound mutation onto `window.__chartSaveDumps[]` so
 * external tooling (chrome-devtools MCP) can pull them. Stripped by Vite
 * in production builds via `import.meta.env.PROD`.
 */

interface ChartSaveDump {
  ts: number
  scope: string
  kind:
    | 'saveLayout'
    | 'mutateTree'
    | 'saveTemplate'
    | 'deleteTemplate'
    | 'updateTemplate'
    | 'saveDrawing'
    | 'deleteDrawing'
    | 'saveChartSettingsProfile'
    | 'deleteChartSettingsProfile'
    | 'saveChartPreferences'
  path: string
  payload: unknown
}

export function recordDump(
  scope: string,
  kind: ChartSaveDump['kind'],
  path: string,
  payload: unknown,
) {
  if (import.meta.env.PROD) return
  if (typeof window === 'undefined') return
  try {
    if (localStorage.getItem('edge-dump-chart-saves') !== '1') return
  } catch {
    return
  }
  const w = window as unknown as { __chartSaveDumps?: ChartSaveDump[] }
  if (!w.__chartSaveDumps) w.__chartSaveDumps = []
  w.__chartSaveDumps.push({
    ts: Date.now(),
    scope,
    kind,
    path,
    payload: payload === undefined ? undefined : JSON.parse(JSON.stringify(payload)),
  })
}
